import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

export default ImmutablePropTypes.mapContains({
  count: PropTypes.number.isRequired,
  tag: PropTypes.string.isRequired
});
